import { ComponentType } from 'react'
import { BlockComponentProps } from '../core/types'
import { BlockConfig, TaskBlock } from './TaskBlock'
import { withUnwrappedSignals } from '../components/UnwrappedSignalsHOC/withUnwrappedSignals'

export class BlockFactory {
    static createBlock<T extends object = object>(config: BlockConfig<T>) {
        return new TaskBlock(config)
    }
}

export class BlockComponentFactory {
    static createBlockComponent<T extends object>(
        component: ComponentType<BlockComponentProps<T>>
    ): ComponentType<BlockComponentProps<T>> {
        return withUnwrappedSignals(component)
    }
}
